import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SmartLink } from '../SmartLink';
import type { Credential } from '../../types/company';
type CredentialRowProps = {
  items: Credential[];
};
export function CredentialRow({
  items
}: CredentialRowProps) {
  return <ul className="grid grid-cols-1 gap-4 lg:grid-cols-3" data-id="element-302" data-mp="3bkq55chy2ffa">
      {items.map(item => {
      const Icon = item.icon;
      return <li key={item.issuer} className="flex h-full flex-col rounded-[14px] border border-canvas-line bg-white p-6" data-id="element-303" data-mp="82pwrw8h8815">
            <div className="flex items-center gap-4" data-id="element-304" data-mp="c2qmid1105ni">
              <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full border-2 border-dashed border-ink/15 bg-canvas-warm text-ink" aria-hidden="true" title="Seal placeholder" data-id="element-305" data-mp="3uhhqrskyl6mi">
                <Icon className="h-6 w-6" strokeWidth={1.6} data-id="element-306" data-mp="qyg13q3vtgi7" />
              </span>
              <div className="min-w-0" data-id="element-307" data-mp="vsk829d5doja">
                <p className="text-[13px] font-medium text-ink-muted" data-id="element-308" data-mp="22cvevnunkyg4">{item.issuer}</p>
                <h3 className="mt-0.5 text-[16px] font-semibold leading-snug tracking-[-0.01em] text-ink" data-id="element-309" data-mp="1ybjmjake9z48">{item.name}</h3>
              </div>
            </div>
            <p className="mt-4 text-[14.5px] leading-[1.55] text-ink-muted" data-id="element-310" data-mp="2c3pzyow5xrzz">{item.line}</p>
            <SmartLink href={item.href} className="group mt-auto inline-flex items-center gap-1.5 pt-5 text-[14px] font-semibold text-brand transition-colors duration-150 ease-out hover:text-brand-hover" data-id="element-311" data-mp="27bg46s8d9xps">
              {item.linkLabel}
              <span className="sr-only" data-id="element-312" data-mp="2v22d0lq73m0u"> for {item.issuer}</span>
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-313" data-mp="2uzg5gm3b16im" />
            </SmartLink>
          </li>;
    })}
    </ul>;
}